import { pick } from './pick';

/** Picks values of properties off from an item. */
export function pickValues<
  T extends object,
  K extends keyof(T)
>(
  item: T,
  fieldsToPick: K[]
): T[K][] {
  return Object.values(pick(item, fieldsToPick));
}
